<template>
    <div class="w-100">
        <div class="loader" v-if="loading"></div>
        <div class="card" v-else>
            <div class="card-header bg-primary text-white">
                <page-title :title="$t('sideMenu.releaseInfo')"></page-title>
            </div>
            <div class="card-body" v-if="hasEditRights">
                <kendo-editor v-model="infoData"
                              :resizable-content="true"
                              :resizable-toolbar="true"
                              :id="'releaseInfo' + _uid"
                              :name="'releaseInfo' + _uid"
                              rows="30"
                              style="min-height: 600px">
                </kendo-editor>

                <div class="form-group mt-2 text-center" v-if="hasEditRights">
                    <button type="button" class="btn btn-primary" @click.stop="saveReleaseInfo">{{ $t('buttons.save.btnText')}}</button>
                </div>
            </div>
        </div>

        <div class="form-group"></div>

        <ReleaseInfo></ReleaseInfo>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper'
    import personalizationService from '../../services/personalization.service';
    import ReleaseInfo from '../../components/administration/ReleaseInfo'
    import PageTitle from '../../components/common/PageTitle';

    Vue.use(EditorInstaller)

    export default {
        components: {
            ReleaseInfo,
            PageTitle
        },
        data() {
            return {
                loading: false,
                infoData: '',
            };
        },
        methods: {
            loadReleaseInfo() {
                this.loading = true;
                personalizationService
                    .loadReleaseInfo()
                    .then(response => {
                        this.loading = false
                        if (response.data) {
                            this.infoData = response.data
                        }
                    })
                    .catch(error => {
                        this.loading = false
                    });
            },
            saveReleaseInfo() {
                this.loading = true;
                personalizationService
                    .saveReleaseInfo(this.infoData)
                    .then(response => {
                        this.loading = false

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.loading = false

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            }

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            hasEditRights() {
                return this.$store.getters.claims.releaseInfo.create
                    || this.$store.getters.claims.releaseInfo.update;
            }
        },
        mounted() {
            this.loadReleaseInfo();
        }
    };
</script>

<style>
</style>
